export interface FilterItemProps<T> {
    name: string
    value?: T
    handleChange?: (value: T) => void
}


export const inputClasses =
    'block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-[#0b6d5e] text-sm leading-6'